import React, { Component } from 'react';
import { get } from 'lodash';
import classifyPoint from 'robust-point-in-polygon';

import Polygon from './polygon';

class ZonePolygon extends Component {
  constructor(props) {
    super(props);

    this.handleMapMounted = this.handleMapMounted.bind(this);
  }

  polyProps(path) {
    const { zone } = this.props;
    const paths = [];
    path.forEach((p, i) => {
      if (i !== path.length - 1) {
        paths.push({ lat: p[1], lng: p[0] });
      }
    });
    return {
      paths,
      key: zone._id,
      fillColor: zone.hexColor,
    };
  }

  handleMapMounted(polygon) {
    this.polygon = polygon;
  }

  calcVehicleCount(poly) {
    const { vehicles = [] } = this.props;

    const vehiclesContained = vehicles.filter((v) => {
      if (v.geo && v.geo.geoJson) {
        const coords = [
          parseFloat(v.geo.geoJson.coordinates[0]),
          parseFloat(v.geo.geoJson.coordinates[1]),
        ];
        if (classifyPoint(poly, coords) !== 1) {
          return true;
        }
      }
      return false;
    });

    return vehiclesContained.length;
  }

  render() {
    const {
      zone, editable, onZoneBoundaryEdit, showLabels,
    } = this.props;
    const zoneBoundary = get(zone, 'boundary.coordinates', []);

    return (
      <div>
        {zoneBoundary.map(([poly]) => (
          <Polygon
            ref={(ref) => {
              this.polygon = ref;
            }}
            onMapMounted={this.handleMapMounted}
            key={`${zone._id}:${poly[0]}:${poly[1]}`}
            polygon={this.polyProps(poly)}
            editable={editable}
            zone={zone}
            onZoneBoundaryEdit={onZoneBoundaryEdit}
            showLabels={showLabels}
            count={this.calcVehicleCount(poly)}
          />
        ))}
      </div>
    );
  }
}

export default ZonePolygon;
